import { AnimatePresence, motion } from "framer-motion";
import Img from 'gatsby-image';
import { rgba } from 'polished';
import React, { useEffect } from "react";
import sidecar from "react-remove-scroll/sidecar";
import { RemoveScroll } from 'react-remove-scroll/UI';
import styled from 'styled-components';
import PrevIcon from '../images/chevron-left-solid.inline.svg';
import NextIcon from '../images/chevron-right-solid.inline.svg';
import CloseIcon from '../images/times-light.inline.svg';
import { STYLES } from "../styles/Styles";
import { COLOURS } from './../styles/Colours';
import Header from "./Header";
import { ProductLink } from './ProductLink';
import { PHOTOS } from './../data/Photos';
import { useState } from "react";
import ModalImg from "./ImageModalPhoto";

const variants = {
  enter: (direction: number) => ({
    x: direction < 0 ? 1000 : -1000,
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction < 0 ? 1000 : -1000,
    opacity: 0
  })
};

const swipeConfidenceThreshold = 10000;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};


interface Props {
  visible: boolean;
  setIsImageModalVisible: any;
  selectedImage?: string;
  setSelectedImage: any;
  handleChangePhoto: any;
  //imageSrc: string;
  image: any;
  direction: 1 | -1 | 0;
}


export const ImageModal = React.memo((props: Props) => {
  const {
    visible,
    setIsImageModalVisible,
    selectedImage,
    setSelectedImage,
    handleChangePhoto,
    direction = 1,
    image
  } = props;

  const [photoDetails, setPhotoDetails] = useState({
    caption: undefined,
    model: undefined,
    lens: undefined,
    settings: undefined,
  });
  const [imageSrc, setImageSrc] = useState();


  const downHandler = (e) => {
    if (e.keyCode === 37) {
      ///left
      handleChangePhoto('prev');
    } else if (e.keyCode === 39) {
      //right
      handleChangePhoto('next');
    }
  }

  const getSrc = (fileName: string) => {
    if (fileName) {
      const parsedFilename = encodeURIComponent(fileName.trim());
      return `/photos/${parsedFilename}.jpg`;
    }
  }

  useEffect(() => {
    window.addEventListener("keydown", downHandler);

    return () => {
      window.removeEventListener("keydown", downHandler);
    };
  }, []);

  useEffect(() => {
    //const imageSrc = props.image ? props.image.node.childImageSharp.fluid.src : undefined;
    const imageSrc = props.image ? props.image.node.name : undefined;
    const caption = PHOTOS[props.image.node.name].caption;
    const model = PHOTOS[props.image.node.name].model;
    const lens = PHOTOS[props.image.node.name].lens;
    const settings = PHOTOS[props.image.node.name].settings;

    setPhotoDetails({
      caption,
      model,
      lens,
      settings
    });
    setImageSrc(imageSrc);
  }, [image]);

  console.log('image props is', props);

  return (
    <>
      {visible &&
        <RemoveScroll sideCar={sidecar}>
          <ImageModalWrapper>
            <ModalContent>
              <Close onClick={() => setIsImageModalVisible(false)}><CloseIcon /> Close</Close>
              <PhotoContainer>
                <SwitchControl onClick={() => handleChangePhoto('prev')}>
                  <PrevIcon />
                </SwitchControl>
                <PhotoWrapper>
                  <AnimatePresence initial={false}>
                    {/* <Photo
                      key={Math.random()}
                      src={getSrc(imageSrc)}
                      custom={direction}
                      variants={variants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                      transition={{
                        x: { type: "spring", stiffness: 300, damping: 200 },
                        opacity: { duration: 0.2 }
                      }}
                      drag="x"
                      dragConstraints={{ left: 0, right: 0 }}
                      dragElastic={1}
                      onDragEnd={(e, { offset, velocity }) => {
                        const swipe = swipePower(offset.x, velocity.x);

                        if (swipe < -swipeConfidenceThreshold) {
                          handleChangePhoto('next');
                        } else if (swipe > swipeConfidenceThreshold) {
                          handleChangePhoto('prev');
                        }
                      }}
                    />         */}
                    <MotionContainer
                      key={Math.random()}
                      custom={direction}
                      variants={variants}
                      initial="enter"
                      animate="center"
                      exit="exit"
                      transition={{
                        x: { type: "spring", stiffness: 300, damping: 200 },
                        opacity: { duration: 0.2 }
                      }}
                      drag="x"
                      dragConstraints={{ left: 0, right: 0 }}
                      dragElastic={1}
                      onDragEnd={(e, { offset, velocity }) => {
                        const swipe = swipePower(offset.x, velocity.x);

                        if (swipe < -swipeConfidenceThreshold) {
                          handleChangePhoto('next');
                        } else if (swipe > swipeConfidenceThreshold) {
                          handleChangePhoto('prev');
                        }
                      }}

                    >
                      <ModalImg image={props.image.node.name}  />
                    </MotionContainer>
                  </AnimatePresence>
                </PhotoWrapper>
                <SwitchControl onClick={() => handleChangePhoto('next')}>
                  <NextIcon />
                </SwitchControl>
              </PhotoContainer>
              {photoDetails &&
                <ImageInfo>
                  <ProductInfo>
                    <Model>Shot on <ProductLink product={photoDetails.model} /></Model>
                    <Details>{photoDetails.settings}</Details>
                  </ProductInfo>
                  <ImageCaption>
                    {photoDetails.caption}
                  </ImageCaption>
                </ImageInfo>
              }
            </ModalContent>
          </ImageModalWrapper>
        </RemoveScroll>
      }
    </>
  )
});

const ImageModalWrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${STYLES.headerSize};
  top: 0;
  left: 0;
  background-color: ${rgba(COLOURS.charcoal, 0.9)};
  color: ${COLOURS.white};
  @media(min-width: ${STYLES.desktopSize}) {
    
  }
`;

const ModalContent = styled.div`
  display: flex;
  max-height: 100vh;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  @media(min-width: ${STYLES.desktopSize}) {
    padding: 6rem 4rem 3rem 4rem;
  }
  @media(max-width: ${STYLES.desktopSize}) {
    max-height: 100vh;
    height: 100vh;
    padding: 6rem 0 0 0;
  }
`;

const PhotoWrapper = styled.div`
  margin: 0 auto;
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
`;

const Photo = styled(motion.img)`
  object-fit: contain;
  user-select: none;
  height: 100%;
  position: absolute;
`;

const MotionContainer = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  user-select: none;
`;

export const Close = styled.div`
  display: flex;
  padding: 1rem;
  flex-shrink: 0;
  margin-left: auto;
  align-items: center;
  @media(max-width: ${STYLES.desktopSize}) {
    padding: 0 2rem 0 2rem;
    height: 50px;
    flex-shrink: 0;
  }
  :hover {
    cursor: pointer;
    opacity: 0.8;
  }
  svg {
    margin-right: 1rem;
    width: 20px;
  }
`;

const PhotoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  position: relative;
`;

const ImageInfo = styled.div`
  display: flex;
  user-select: none;
  @media(min-width: ${STYLES.desktopSize}) {
    width: 60vw;
    margin-top: 1rem;
  }
  @media(max-width: ${STYLES.desktopSize}) {
    flex-direction: column;
    padding: 1.5rem;
    font-size: ${STYLES.textSize2};
    width: 100%;
    height: 30vh;
    min-height: min-content;
    max-height: 180px;
  }
`;

const ProductInfo = styled.div`
  flex: 1;
  margin-right: 1rem;
`;

const Model = styled.div`
  font-weight: 700;
`;

const Details = styled.div`
`;

const ImageCaption = styled.div`
  flex: 3;
  @media(max-width: ${STYLES.desktopSize}) {
    margin-top: 1rem;
  }
`;

const SwitchControl = styled.div`
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 250ms ${STYLES.easeOutQuint};
  border-radius: 50%;
  z-index: 3;
  @media(max-width: ${STYLES.desktopSize}) {
    position: absolute;
    :first-child {
      left: 0;
    }
    :last-child {
      right: 0;
    }
  }
  :hover {
    cursor: pointer;
    background-color: rgba(255,255,255,0.2);
  }
  svg {
    height: 50%;
    width: 50%;
  }
`;
